var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_3113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99609 11.7294C10.1968 11.9977 10.4529 12.2197 10.7469 12.3804C11.041 12.541 11.3661 12.6366 11.7003 12.6605C12.0346 12.6844 12.37 12.6362 12.684 12.5191C12.9979 12.402 13.283 12.2187 13.5199 11.9818L14.9219 10.5797C15.3476 10.139 15.5831 9.54874 15.5778 8.93606C15.5725 8.32337 15.3267 7.73729 14.8935 7.30404C14.4602 6.87079 13.8741 6.62504 13.2614 6.61972C12.6488 6.61439 12.0585 6.84992 11.6178 7.27558L10.8139 8.07474",
    stroke: "#0065ff",
    strokeWidth: 0.934692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.865 10.7947C11.6643 10.5264 11.4082 10.3044 11.1142 10.1437C10.8201 9.98305 10.495 9.88751 10.1607 9.86357C9.82651 9.83964 9.49105 9.88786 9.17711 10.005C8.86317 10.1221 8.57808 10.3053 8.34119 10.5423L6.93915 11.9444C6.5135 12.3851 6.27797 12.9753 6.28329 13.588C6.28862 14.2007 6.53437 14.7868 6.96762 15.22C7.40086 15.6533 7.98695 15.899 8.59963 15.9044C9.21231 15.9097 9.80258 15.6741 10.2433 15.2485L11.0425 14.4493",
    stroke: "#0065ff",
    strokeWidth: 0.934692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.45056,
    width: 19.3609,
    height: 19.3609,
    rx: 9.68044,
    stroke: "#0065ff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_3113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.2163,
    height: 11.2163,
    fill: "white",
    transform: "translate(5.32227 5.65387)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share-link.c87dcc10c2be81ff0d8dd2fc6d671895.svg";
export { ForwardRef as ReactComponent };